<template>
	<div :class="{'full-parent' : !mobile}">
		<div :class="{'header full-parent' : true, 'mb-header' : mobile}">
			<div :class="{'hero-info-container flex-center full-height':true, 'mb-hero-info-ct' : mobile}">
				<div class="full-width">
					<p class="number-text">
						累积 <span class="number">{{num}}</span> 人祭奠
					</p>
					<el-image :src="hero.img" style="margin-top: 20px;width: 137px;height: 185px;"></el-image>
					<p class="person-name">{{hero.name}}</p>
					<div class="life">
						<p class="text-center">{{hero.simpleInfo}}</p>
					</div>
					<div class="flex-center">
						<div class="comment-form-container flex-center">
							<span class="comment-input-label">祭奠者：</span>
							<input v-model="form.name" class="comment-input" style="height: 35px;" placeholder="请输入你的名字" />
						</div>
					</div>
					<div class="flex-center">
						<div class="comment-form-container flex-center" style="margin-top: 0;">
							<span class="comment-input-label">留言：</span>
							<textarea v-model="form.content" class="comment-input" placeholder="缅怀先烈，致敬英雄" />
							</div>
					</div>
					<div class="flex-center">
						<div class="btn-submit-con flex-center hand-cursor" @click="submitComment">
						<span class="btn-text">发布</span>
						</div>
					</div>
					
					
				</div>
			</div>
      <div class="jidian-container">
        <div class="jidian-bei">
          <div class="name">{{hero.name}}</div>
        </div>
        <div class="jidian-zhuo"></div>
        <div class="jibai" :class="{'fade':isJiBai1}" v-show="isJiBai"><!-- -->
          <div :style="{marginLeft: jibaiPosition}">
            <img src="/static/img/jibai.png" style="height: 460px;" alt="">
          </div>
        </div>
        <div class="xianhua" v-show="isXianHua">
          <div style="display: flex;justify-content: space-between;">
            <img :src="huaImg" alt="" style="height: 120px;">
            <img :src="huaImg" alt="" style="height: 120px;">
          </div>
        </div>
        <div class="dianla" v-show="isDianLa">
          <div style="display: flex;justify-content: space-between;">
            <img :src="laImg" alt="" style="width: 48px;height: 94px;">
            <img :src="laImg" alt="" style="width: 48px;height: 94px;">
          </div>
        </div>
        <div class="shangxiang" v-show="isXiang">
            <img :src="xinagImg" alt="" style="width:62px;height: 132px;">
            <img :src="guopanImg" alt="" style="width: 91px;height: 76px;margin-left: 5px;">
        </div>
      </div>
	  <div class="jidian-list">
	    <template v-for="(item,index) in jiList">
	      <div class="jidian-list-hua-box" @click="ji(index)">
	        <div><img class="jidian-list-hua" :src="item.img" alt=""></div>
	        <div style="color: #38932E;font-size: 16px;">{{item.txt}}</div>
	      </div>
	    </template>
	  </div>
	  <div class="jidian-hua-list" v-show="visibleSelHua">
	    <template v-for="(item,index) in huaList">
	      <div class="jidian-hua-list-box" @click="selHua(index)">
	        <img class="jidian-hua-list-img" :src="item" alt="" >
	      </div>
	    </template>
	  </div>
		</div>
 

    <div class="leavingmsg-container">
      <div class="leavingmsg-show">留言展示</div>
      <div class="leavingmsg-list">
        <template v-for="item in comments.content">
          <div class="leavingmsg-list-item">
            <div class="leavingmsg-info">
              <span class="leavingmsg-name">{{item.name}}</span>
              <span class="leavingmsg-date">{{deteFormat(new Date(item.publishTime), "yyyy.MM.dd hh:mm:ss")}}</span>
            </div>
            <div class="leavingmsg-content">{{item.content}}</div>
            <div class="border-dashed"></div>
          </div>
        </template>
        <div class="pn" style="margin-top: 50px;">
          <el-pagination
            background
            layout="prev, pager, next"
			@current-change="changePage"
            :total="comments.totalElements">
          </el-pagination>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
	import api from '../../http/commemorate'
	import detailApi from '../../http/detail'
	import {
		formatTimeToStr
	} from '../../utils/date.js'
	export default {
		data() {
			return {
        huaImg:'/static/img/f1.png',
        laImg:'/static/img/zhutai.png',
        xinagImg:'/static/img/xiang.png',
        guopanImg:'/static/img/shuiguo.png',
        jibaiTimer:null,
        isJiBai:false,
        isJiBai1:false,
        isXianHua:false,
        isDianLa:false,
        isXiang:false,
        jibaiPosition:'0px',
        jiList:[
          {txt:'祭拜',img:'/static/img/ren.png'},
          {txt:'献花',img:'/static/img/f1.png'},
          {txt:'点蜡',img:'/static/img/zhutai.png'},
          {txt:'上香',img:'/static/img/xiang.png'},
        ],
        visibleSelHua:false,
        huaList:['/static/img/f1.png','/static/img/f2.png','/static/img/f3.png','/static/img/f4.png'],
		num : null,
		form :{
			name : null,
			content : null,
			heroId : null
		},
		hero : {
			img : "/static/img/white.png"
		},
		page : {
			page : 0,
			size : 10,
			sort : "id,desc"
		},
		comments:[],
		mobile : false
		
			}
		},
    mounted() {
    },
		methods: {
      selHua(index){
        this.huaImg=this.huaList[index]
        this.isXianHua=true
        this.visibleSelHua=false
      },
      ji(index){
        if(index==0){
			if(!this.isJiBai){
          this.isJiBai=true
          this.isJiBai1=false
          this.jibaiPosition='0px'
          this.jibai()
		  this.addNum()
		  }
		  
        }
        else if(index==1){
          this.visibleSelHua=true
        }
        else if(index==2){
          this.isDianLa=true
        }
        else if(index==3){
          this.isXiang=true
        }
      },
      jibai(){
        let t=0
        let num=0
        let jibaiStep=226
        let jibaiNum=0
        this.jibaiTimer=setInterval(()=>{
          this.jibaiPosition='-'+(jibaiNum*jibaiStep)+'px'
          if(t==0){
            jibaiNum++
          }
          else{
            jibaiNum--
          }
          if(jibaiNum==10){
            t=1
          }
          else if(jibaiNum==0){
            t=0
            num++
          }
          if(num==3){
            clearInterval(this.jibaiTimer)
            setTimeout(()=>{
              this.isJiBai1=true
            },2000)

            setTimeout(()=>{
              this.isJiBai=false
            },3000)
          }
        },150)
      },
			submitComment(){
				api.personalComment(this.form).then(res => {
					this.form.name = null;
					this.form.content = null;
					this.getComments();
					this.$alert("留言成功", '提示', {
													confirmButtonText: '确定',
													type : "success"
					       });
				}).catch(err => {
					 this.$alert(err.message, '留言失败', {
								confirmButtonText: '确定',
								type : "error"
					        });
				})
			},
			getCommemorateNum(){
				const _this = this;
				api.getCommemorateNum().then(res => {
					_this.num = res;
				})
			},
			addNum(){
				const _this = this;
				api.commemorate().then(res => {
					_this.num = res;
				})
			},
			getHeroDetail(){
				const _this = this;
				detailApi.getHeroDetail(this.form.heroId).then(res => {
					_this.hero = res;
				})
			},
			getComments(){
				const _this = this;
				api.getPersonalComments(this.page).then(res => {
					_this.comments = res;
				})
			},
			changePage(current){
				this.page.page = current - 1;
				this.getComments();
			},
			deteFormat(date, formatter) {
				return formatTimeToStr(date, formatter);
			},
			isMobile() {
				if (navigator.userAgent.match(
						/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)) {
					this.mobile = true;
				} else {
					this.mobile - false;
				}
				console.log('是否为移动端 : ', this.mobile)
			},
		},
		created() {
			var query = this.$route.query;
			this.form.heroId = query.hero;
			this.getHeroDetail();
			this.getCommemorateNum();
			this.getComments();
			this.isMobile();
		}
	}
</script>

<style scoped>
  .xianhua{position: absolute;top: 420px;width: 530px;z-index: 1;left: 0;right: 0;margin: auto;}
  .dianla{position: absolute;top: 450px;width: 376px;z-index: 3;left: 0;right: 0;margin: auto;}
  .shangxiang{position: absolute;top: 420px;width: 376px;z-index: 3;left: 0;right: 0;margin: auto;}
  @-webkit-keyframes fadeIn {
      0% {
        opacity: 1; /*初始状态 透明度为0*/
      }
      50% {
        opacity: 0; /*中间状态 透明度为1*/
      }
    }
  .fade {
      -webkit-animation: fadeIn 2s infinite linear;
    }
  .jibai{
    width: 220px;
    position: absolute;
    bottom: -60px;
    left: 0;
    right: 0;
    margin: auto;
    overflow: hidden;
    z-index: 4;
  }
  .jidian-list{
    position: absolute;
    width: 80px;
    bottom: 100px;
    right: 40px;
	z-index: 999;
  }
  .jidian-list-hua-box{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #fff;
    margin-bottom:16px;
    cursor: pointer;
  }
  .jidian-list-hua{
    margin-top: 6px;
    width: 30px;
    height: 46px;
  }
  .jidian-hua-list{position: absolute;width: 120px;bottom: 0;right: 110px;background-color: rgba(0,0,0,0.3);padding: 20px 0;}
  .jidian-hua-list-box{cursor: pointer;margin: 10px 0;}
  .jidian-hua-list-img{height: 86px;}

  .name{
        font-size: 36px;
        color: #000000;
        width: 160px;
        height: 150px;
        position: absolute;
        left: -5px;
        right: 0;
        top: -56px;
        bottom: 0;
        margin: auto;
        writing-mode: vertical-lr;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 1.12;
        letter-spacing: 0.3em;
  }
  .jidian-container{
    width: 701px;
    height: 792px;
    margin-left: 144px;
    margin-top: 42px;
    position: relative;
  }
  .jidian-bei{
    width: 620px;
    height: 684px;
    margin: 0 auto;
    background-image: url("/static/img/bei.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
  }
  .jidian-zhuo{
    width: 701px;
    height: 266px;
    margin: 0 auto;
    background-image: url("/static/img/zhuo.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    z-index: 2;
  }
	.header {
		position: relative;
		display: flex;
		align-items: center;
		background-image: url("/static/img/commemorate/spring.jpg");
		background-size: 100%;
		background-repeat: no-repeat;
	}
	.mb-header{
		background-repeat: round !important;
	}

	.hero-info-container {
    margin-top: 7%;
		margin-left: 12%;
		width: 33%;
		height: 72%;
		background: rgba(200, 242, 232, 0.65);
	}
	.mb-hero-info-ct{
		margin-left: 0 !important;
	}

	.number-text {
		font-size: 22px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #27A842;
	}

	.number {
		color: #32AA42;
		font-size: 32px;
		font-weight: 900;
	}

	.person-name {
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #268E34;
		margin: 10px 0;
	}

	.life {
		padding: 0 20px;
		height: 90px;
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #32AA42;
		line-height: 30px;
		overflow-y: scroll;
	}
	.life::-webkit-scrollbar {
	  width: 15px;
	  border-radius: 6px;
	  background-color: rgba(240, 240, 240, 1);
	}
	.life::-webkit-scrollbar-thumb {
		box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
	    border-radius: 6px;
	     background-color: #32AA42;
	}
	.comment-form-container {
		width: 100%;
		margin: 20px 7%;
		height: 76px;
		background: #32AA42;
		border-radius: 38px;
	}

	.comment-input-label {
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 7px;
	}

	.comment-input {
		display: flex;
		align-items: center;
		padding: 5px 10px;
		width: 70%;
		height: 40px;
		background: #AEDB8F;
		border: 0;
		outline: none;
		font-size: 18px;
		color: #FFFFFF;
	}
	.comment-input::placeholder{
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #32AA42;
		line-height: 40px;
	}
	.btn-submit-con{
		width: 120px;
		height: 50px;
		border-radius: 25px;
		background: #32AA42;
		border: 1px solid #AEDB8F;
	}
	.btn-text{
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
	}
  .leavingmsg-container{background-color: #fff;padding-top: 90px;color: #268E34;}
  .leavingmsg-box{width: 628px;height: 74px;border: 1px solid #fff;border-radius: 37px;margin:0 auto;background-color: #4B5E7B;display: flex;align-items: center;font-size: 20px;font-family: Microsoft YaHei;}
  .leavingmsg-input{background-color: #3A4960;border: 0;line-height: 50px;font-size: 20px;padding: 0 18px;width: 320px;}
  .leavingmsg-btn{margin-left: 18px;width: 148px;line-height: 48px;border: 1px solid #fff;border-radius: 29px;text-align: center;}
  .leavingmsg-show{width: 249px;line-height: 71px; background-image: url("/static/img/liuyan.png");background-size: 100% 100%;background-repeat: no-repeat;margin: 103px auto 0;font-size: 24px;text-align: center;}
  .leavingmsg-list{width: 1320px;margin: 0 auto;padding: 50px 0;}
  .leavingmsg-info{text-align: left;margin-top: 30px;padding-left: 10px;}
  .leavingmsg-name{font-weight: bold;font-size: 20px;}
  .leavingmsg-date{font-size: 16px;margin-left: 20px;}
  .leavingmsg-content{text-align: left;font-size: 18px;margin-top: 30px;padding-left: 10px;}
  .border-dashed{height: 1px;margin-top: 30px;border-bottom: 1px #268E34 dashed;}
</style>



// WEBPACK FOOTER //
// src/views/commemorate/personal.vue